import React from 'react';
import { processSteps } from '../utils/mockData';
import { MessageSquare, MapPinned, LineChart, FileText } from 'lucide-react';

const iconMap = {
  MessageSquare: MessageSquare,
  MapPinned: MapPinned,
  LineChart: LineChart,
  FileText: FileText
};

const Process = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 text-blue-900 rounded-full text-sm font-semibold mb-4">
            How We Work
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Surveying Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A systematic approach to delivering accurate and reliable survey results
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {processSteps.map((step, index) => {
            const IconComponent = iconMap[step.icon];
            return (
              <div key={step.step} className="relative">
                {/* Connector Line (desktop only) */}
                {index < processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-16 left-[60%] w-full h-0.5 bg-gradient-to-r from-blue-900 to-blue-300 z-0"></div>
                )}
                
                <div className="relative z-10 text-center group">
                  {/* Step Number Circle */}
                  <div className="mb-6 flex justify-center">
                    <div className="relative">
                      <div className="w-32 h-32 bg-gradient-to-br from-blue-900 to-blue-700 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-xl">
                        <IconComponent className="w-12 h-12 text-white" />
                      </div>
                      <div className="absolute -top-2 -right-2 w-10 h-10 bg-white border-4 border-blue-900 rounded-full flex items-center justify-center font-bold text-blue-900 shadow-lg">
                        {step.step}
                      </div>
                    </div>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-900 transition-colors">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
